import styled from 'styled-components';
import Link from 'next/link';
// components
import Avatar from 'components/atoms/photos/Avatar';
import StarRating from 'components/atoms/rating/StarRating';
// styles
import { palette } from 'cds/styles';

/**
 * 사이드 클래스 정보
 * @param {object} props
 * @param {string} props.photo
 * @param {number} props.coachId
 * @param {string} props.coachName
 * @param {string} props.className
 * @param {{
 * 	score: number;
 *  count: number;
 * }} props.review
 */
const ClassInfo = ({ classId, photo, coachId, coachName, className, review }) => {
  const isExistReview = review.count > 0;

  return (
    <Layout>
      <Link href={`/user/${coachId}`} passHref>
        <CoachLayout>
          <Avatar width={18} height={18} src={photo} alt={coachName} />
          <span>{coachName}</span>
        </CoachLayout>
      </Link>

      <ClassName>{className}</ClassName>

      {isExistReview && (
        <StarLayout>
          <StarRating value={review.score} xsmall />
          {
            <>
              <span>{Math.ceil(review.score * 10) / 10}</span>
            </>
          }
          <span>({review.count})</span>
        </StarLayout>
      )}
    </Layout>
  );
};

const Layout = styled.div`
  margin-bottom: 16px;
`;

const CoachLayout = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  min-height: 24px;
  margin-bottom: 4px;

  & > div {
    width: 18px;
    margin: 0;
  }

  & > span {
    margin-left: 4px;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const ClassName = styled.h1`
  min-height: 24px;
  margin-bottom: 8px;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  color: ${palette.black};
  word-break: break-all;
`;

// TODO PHP와 임시적으로 색상 통일되어있음
const StarLayout = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 16px;
  margin-bottom: 10px;

  & > span {
    margin-top: -1px;
    margin-left: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: #b4b4b4;
  }
`;

export default ClassInfo;
